export const itemTypes = {
    pd: "PD",
    pi: "PI",
    oof: "OOF",
    lf: "LF",
    monthly: "Monthly"
};